import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'
import { useApiErrorHandler } from '../../../useApiErrorHandler'

interface UpdateScheduledMessageData {
  id: string
  message?: string
  recipientAccountId?: string
  groupId?: string
  scheduledDate?: string // ISO date string
}

const updateScheduledMessage = async (data: UpdateScheduledMessageData): Promise<void> => {
  const { id, ...updateData } = data
  await api.put(`/scheduled-message/${id}`, updateData)
}

export const useUpdateScheduledMessage = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()
  const handleApiError = useApiErrorHandler()

  return useMutation<void, Error, UpdateScheduledMessageData>({
    mutationFn: updateScheduledMessage,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.scheduledMessageUpdated'))
      await queryClient.invalidateQueries({ queryKey: ['scheduled-messages'] })
    },
    // A refused save says so instead of failing in silence.
    onError: handleApiError,
  })
}

